import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import ApplyNowModal from "../ApplyNowModal";
import { useState } from "react";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

const jobs = [
  {
    title: "Fabrication Engineer",
    location: "Sharjah, UAE",
    type: "Full Time",
    img: "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
  },
  {
    title: "Welding Supervisor",
    location: "Sharjah, UAE",
    type: "Full Time",
    img: "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
  },
  {
    title: "Quality Inspector",
    location: "Sharjah, UAE",
    type: "Full Time",
    img: "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
  },
  {
    title: "Design Engineer (AutoCAD)",
    location: "Sharjah, UAE",
    type: "Full Time",
    img: "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
  },
  {
    title: "Project Coordinator",
    location: "Sharjah, UAE",
    type: "Full Time",
    img: "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw",
  },
];

const JobOpenings = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");

  const handleOpenModal = (jobName) => {
    setSelectedJob(jobName || "General Application");
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedJob(""); // Prevent stale values
  };
  return (
    <Box sx={{ py: 8, background: "#f9f9f9" }}>
      <Typography
        variant="h4"
        fontWeight={700}
        align="center"
        sx={{
          color: brandBlue,
          mb: 4,
          fontSize: {
            xs: "1.6rem", // Mobile
            sm: "2rem", // Small Tablets
            md: "2.4rem", // Larger screens
          },
          lineHeight: 1.2,
          px: 2,
        }}
      >
        Current Job Openings
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 3,
          justifyContent: "center",
          px: 2,
        }}
      >
        {jobs.map((job, index) => (
          <Card
            key={index}
            sx={{
              width: { xs: "100%", sm: "48%", md: "30%" },
              borderRadius: 3,
              p: 2,
              display: "flex",
              gap: 2,
              alignItems: "center",
              boxShadow: "0px 4px 14px rgba(0,0,0,0.08)",
              transition: "0.3s",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0px 6px 18px rgba(0,0,0,0.12)",
              },
            }}
          >
            {/* Image Column */}
            {/* <img
              src={job.img}
              alt={job.title}
              style={{
                width: "110px",
                height: "110px",
                objectFit: "cover",
                borderRadius: "10px",
              }}
            /> */}

            {/* Details Column */}
            <CardContent
              sx={{
                p: "0 !important",
                flex: 1,
              }}
            >
              <Typography variant="h6" fontWeight={700} mb={1}>
                {job.title}
              </Typography>

              <Typography variant="body2" mb={1}>
                📍 {job.location}
              </Typography>

              <Typography variant="body2" mb={2}>
                ⏱ {job.type}
              </Typography>

              <Button
                variant="contained"
                size="small"
                onClick={() => handleOpenModal(job.title)}
                sx={{
                  background: brandRed,
                  borderRadius: "20px",
                  px: 2,
                  textTransform: "none",
                  "&:hover": { background: "#b40000" },
                }}
              >
                Apply Now
              </Button>
            </CardContent>
          </Card>
        ))}
      </Box>
      <ApplyNowModal
        open={modalOpen}
        onClose={handleCloseModal}
        selectedJob={selectedJob}
      />
    </Box>
  );
};

export default JobOpenings;
